/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { NgModule } from '@angular/core';

import { BuilderSharedModule } from '@gh/builder-shared';

import { BuilderSetupReportSettingsRoutingModule } from './builder-setup-report-settings-routing.module';
import { ReportFyaDetailsComponent } from './components/report-financials-ytd-average-details/report-fya-details.component';
import { ReportFyaIndexValuesTabComponent } from './components/report-financials-ytd-average-details/report-fya-index-values-tab/report-fya-index-values-tab.component';
import { ReportFyaKeyGoalsTabComponent } from './components/report-financials-ytd-average-details/report-fya-key-goals-tab/report-fya-key-goals-tab.component';
import { ReportRohcAreaDialogComponent } from './components/report-region-office-house-cost-details/report-rohc-area-dialog/report-rohc-area-dialog.component';
import { ReportRohcAreaManagementComponent } from './components/report-region-office-house-cost-details/report-rohc-area-management/report-rohc-area-management.component';
import { ReportRohcCcManagementComponent } from './components/report-region-office-house-cost-details/report-rohc-cc-management/report-rohc-cc-management.component';
import { ReportRohcDetailsComponent } from './components/report-region-office-house-cost-details/report-rohc-details.component';
import { ReportRohcMasterCcDialogComponent } from './components/report-region-office-house-cost-details/report-rohc-master-cc-dialog/report-rohc-master-cc-dialog.component';
import { ReportSettingsTabContainerComponent } from './components/report-settings-tab-container/report-settings-tab-container.component';
import { ReportFyaDetailsBusinessService } from './resources/report-fya-details-business.service';
import { ReportRohcDetailsBusinessService } from './resources/report-rohc-details-business.service';

@NgModule({
  imports: [
    BuilderSharedModule.forChild(),
    BuilderSetupReportSettingsRoutingModule,
  ],
  providers: [
    ReportRohcDetailsBusinessService,
    ReportFyaDetailsBusinessService,
  ],
  declarations: [
    ReportSettingsTabContainerComponent,
    ReportRohcDetailsComponent,
    ReportRohcAreaManagementComponent,
    ReportRohcCcManagementComponent,
    ReportRohcAreaDialogComponent,
    ReportRohcMasterCcDialogComponent,
    ReportFyaDetailsComponent,
    ReportFyaIndexValuesTabComponent,
    ReportFyaKeyGoalsTabComponent,
  ],
})
export class BuilderSetupReportSettingsModule {
}
